var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 0H0v16h24V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M13.5 0h-3v6.499H0v2.997h10.5v6.499h3v-6.5H24V6.5H13.5V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0853AD",
    d: "M14.61 10.78 24 15.995V14.52l-6.74-3.74h-2.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M14.61 10.78 24 15.995V14.52l-6.74-3.74h-2.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M14.61 10.78 24 15.995V14.52l-6.74-3.74h-2.65ZM6.734 10.78 0 14.52v1.475l9.39-5.215H6.734Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0853AD",
    d: "M9.39 5.215 0 0v1.475l6.734 3.74H9.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M9.39 5.215 0 0v1.475l6.734 3.74H9.39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M9.39 5.215 0 0v1.475l6.734 3.74H9.39Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#001E5E",
    d: "M18.458 10.78 24 13.86v-3.08h-5.542ZM21.498 15.995l-6.888-3.827v3.827h6.888ZM4.237 10.78 0 13.132V10.78h4.237ZM9.39 11.44v4.555H1.192L9.39 11.44ZM5.542 5.215 0 2.135v3.08h5.542ZM2.502 0 9.39 3.827V0H2.502ZM19.763 5.215 24 2.863v2.352h-4.237ZM14.61 4.55V0h8.193L14.61 4.55Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7002C",
    d: "M17.26 5.215 24 1.475V0l-9.39 5.215h2.65Z"
  })));
};
export default SvgUk;